module.exports = __webpack_public_path__ + "img/productSatellite_12.7eed0bd0.png";